import { useCallback, useEffect, useRef, useState } from 'react'
import { usePage } from '@inertiajs/react'
import type { PageProps } from '@/types/inertia.d'

export function useTopBarVM() {
  const { props } = usePage<PageProps>()
  const flash = props.flash
  const user = props.auth?.user

  const userInitial = user?.name?.[0]?.toUpperCase() ?? 'A'

  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const userMenuRef = useRef<HTMLDivElement>(null)

  const toggleUserMenu = useCallback(() => {
    setUserMenuOpen((prev) => !prev)
  }, [])

  useEffect(() => {
    if (!userMenuOpen) return

    const handleClickOutside = (e: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target as Node)) {
        setUserMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [userMenuOpen])

  return {
    notice: flash?.notice ?? null,
    alert: flash?.alert ?? null,
    userInitial,
    userMenuOpen,
    userMenuRef,
    toggleUserMenu,
  }
}
